import { ClientConfig } from "./types";
import configToml from "../../config.toml";

class GlobalManager {
  public tick: number = 0;
  public readonly config: ClientConfig;
  constructor() {
    this.config = configToml as unknown as ClientConfig;
  }
}

export const Globals = new GlobalManager();
